// @flow
export const ConfigAggregators = {
  Plaid: 'Plaid',
  MX: 'MX',
  Finicity: 'Finicity',
};

export type TConfigAggregators = $Keys<typeof ConfigAggregators>;

export type TConfigAggregatorOptions = {
  link_token: ?string,
  connect_url: ?string,
};

export type TConfigOptions = {
  initialized?: boolean,
  token?: ?string;
  entity_id?: ?string;
  mch_id?: ?string;
  mask?: ?string;
  team_name?: ?string;
  aggregator: ?TConfigAggregators,
  aggregator_options: ?TConfigAggregatorOptions,
};
